<div class="main-spinner {{ color }}">
  <div class="ball"></div>
  <div class="ball delay2"></div>
  <div class="ball delay4"></div>
</div>
